import React, { memo } from 'react';
import PropTypes from 'prop-types';

import {
  EMPTY_RATE,
  splitCurrencyYearArchiveNbuRate,
} from 'utils/currencyYearArchive';

import { RateValue, RateValueSuffix } from './styles';

const CurrencyYearArchiveNbuRateValue = memo(({ value, formatNumber }) => {
  const parts = splitCurrencyYearArchiveNbuRate(value, formatNumber);

  if (!parts) {
    return <RateValue>{EMPTY_RATE}</RateValue>;
  }

  return (
    <RateValue>
      {parts.main}
      {parts.suffix ? <RateValueSuffix>{parts.suffix}</RateValueSuffix> : null}
    </RateValue>
  );
});

CurrencyYearArchiveNbuRateValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  formatNumber: PropTypes.func.isRequired,
};

CurrencyYearArchiveNbuRateValue.defaultProps = {
  value: null,
};

export default CurrencyYearArchiveNbuRateValue;
